module.exports = __webpack_public_path__ + "static/img/HannahPetty.42a8a96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/HannahPetty.jpg
// module id = 4yoW
// module chunks = 0